var map = {
	"./10 1.png": 3601,
	"./HD loogo.png": 9039,
	"./PolicyBanner1.png": 7186,
	"./PolicyBanner2.png": 1193,
	"./PolicyBanner3.png": 5440,
	"./about-banner-img.png": 4531,
	"./aboutbg.png": 1265,
	"./aboutus.png": 5448,
	"./assess-banner.png": 3542,
	"./bannerbg.png": 4480,
	"./book-icon.png": 9552,
	"./cag1.png": 5911,
	"./cag2.png": 7180,
	"./cag4.png": 26,
	"./cag5.png": 787,
	"./cag6.png": 6296,
	"./campus-map.png": 7501,
	"./comp-course.png": 9594,
	"./courses-detail.png": 135,
	"./cs-logo.png": 7825,
	"./dots.png": 9871,
	"./favicon.png": 5963,
	"./fb.png": 6627,
	"./footer-border.png": 7099,
	"./footer-logo.png": 4716,
	"./frame-old.png": 7900,
	"./frame.png": 7588,
	"./google.png": 6702,
	"./half-img 1.png": 5083,
	"./his-message.png": 1049,
	"./hist-rocket.png": 6202,
	"./holiday.png": 5183,
	"./icon-arrow.png": 2212,
	"./icon-idea.png": 4574,
	"./icon-paper.png": 8345,
	"./icon-percent.png": 4604,
	"./learningbg.png": 4052,
	"./lft.png": 4377,
	"./li-arrow.png": 7570,
	"./linkedin.png": 5405,
	"./logo_franchise.png": 3114,
	"./logo_group.png": 3050,
	"./logo_institute.png": 6498,
	"./logo_online.png": 1858,
	"./logo_testbank.png": 4949,
	"./main image.png": 3071,
	"./mapblogdt.png": 8473,
	"./mat.png": 7757,
	"./maths.png": 2926,
	"./mathskill.png": 5310,
	"./meet-bg.png": 8328,
	"./offerbg.png": 600,
	"./owl-banner.png": 1658,
	"./pencil-boy.png": 6537,
	"./pencil-girl.png": 4989,
	"./planet.png": 7141,
	"./ray-icon.png": 5525,
	"./ray-iconabt.png": 1822,
	"./reading.png": 1559,
	"./reason.png": 9119,
	"./rocket.png": 1027,
	"./rockett.png": 5823,
	"./rt-arrow.png": 5629,
	"./rt.png": 6561,
	"./shadow 8.png": 1487,
	"./sim-course.png": 5626,
	"./skil.png": 5450,
	"./skill.png": 6812,
	"./skill23.png": 437,
	"./star-icon.png": 9777,
	"./stepbg.jpg": 4048,
	"./supplement.png": 6482,
	"./teacher.png": 7233,
	"./touchbg.png": 2971,
	"./touchrt-icon.png": 4484,
	"./trial.png": 8319,
	"./tw.png": 7032,
	"./vd-bg.png": 3945,
	"./visionbg.png": 6250,
	"./writing.png": 3723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2180;